import { render, staticRenderFns } from "./BookDemo.vue?vue&type=template&id=26b7bc92&scoped=true"
import script from "./BookDemo.vue?vue&type=script&lang=js"
export * from "./BookDemo.vue?vue&type=script&lang=js"
import style0 from "./BookDemo.vue?vue&type=style&index=0&id=26b7bc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b7bc92",
  null
  
)

export default component.exports